<script>

  import {dateFormat, getDefaultDate} from '../assets/js/funcs'

  export default {
    name: 'DatePicker',
    data() {
      return {
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '本月',
            onClick(picker) {
              let d = new Date();
              const start = new Date(d.getFullYear(), d.getMonth(), 1)
              const end = new Date(d.getFullYear(), d.getMonth(), d.getDate())
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '上个月',
            onClick(picker) {
              let d = new Date();
              const monthFirstDay = new Date(d.getFullYear(), d.getMonth(), 1)
              const start = new Date(d.getFullYear(), d.getMonth() - 1, 1);
              const end = new Date();
              end.setTime(monthFirstDay.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '今年',
            onClick(picker) {
              let d = new Date();
              const start = new Date(d.getFullYear(), 0, 1);
              const end = new Date();
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '去年',
            onClick(picker) {
              let d = new Date();
              const start = new Date(d.getFullYear() - 1, 0, 1);
              const end = new Date(d.getFullYear(), 0, 1)
              end.setTime(end.getTime() - 3600 * 100 * 24)
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        defaultDateValue: []
      }
    },
    created() {
      this.defaultDateValue = getDefaultDate()
      this.$emit('datePickerChange', {'start_date': this.defaultDateValue[0], 'end_date': this.defaultDateValue[1]})
    },
    methods: {
      datePickerChange(picker) {
        if (picker) {
          this.$emit('datePickerChange', {'start_date': dateFormat(picker[0]), 'end_date': dateFormat(picker[1])})
        } else {
          this.$emit('datePickerChange', {'start_date': '', 'end_date': ''})
        }
      }
    }
  }
</script>

<template>
  <el-date-picker
    v-model="defaultDateValue"
    type="daterange"
    align="left"
    unlink-panels
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    size="small"
    clearable
    :picker-options="pickerOptions"
    @change="datePickerChange"
    class="date_picker">
  </el-date-picker>
</template>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/DatePicker.vue